<template>
  <el-dialog
    :visible="dialogVisible"
    width="680px"
    @close="closeModal"
    center>
    <div class="title" slot="title">确定上传{{menuData['title']}}的文档吗</div>
    <el-form 
      label-width="150px" 
      ref="form" 
      :rules="ruleData"
      :model="formData">
      <el-form-item class="margin-b20" label="发布类型" prop="publishState" :rules="[  { required: true, message: '不能为空'},  ]" >
        <el-radio v-model="formData.publishState" :label="3">立即发布</el-radio>
        <el-radio v-model="formData.publishState" :label="2">定时发布</el-radio>
      </el-form-item>
      <div class="date-box margin-b30" v-if="formData.publishState==2">
        <el-form-item label="发布时间" prop="publishTime" :rules="[  { required: true, message: '不能为空'},  ]" >
          <el-date-picker
            v-model="formData.publishTime"
            type="datetime"
            value-format="timestamp"
            :picker-options="pickerOptions"
            placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
      </div>
      <el-form-item label="上传文件" prop="pdfUrl" :error="uploadErrorInfo">
          <wk-upload
           class="w360"
           accept=".pdf,.PDF"
           @uploadChange="handleImgChange"
           :imgUrl="formData.pdfUrl"
          ></wk-upload>
      </el-form-item>
			<el-form-item label="文档描述" prop="desc">
				<el-input
					:rows="6"
					:maxlength="120"
					show-word-limit
					type="textarea"
					class="w400" v-model="formData.desc" placeholder="请输入描述内容"></el-input>
			</el-form-item>
    </el-form>
    <div class="footer">
      <wk-button type="primary" class="exportButton" @click="onSubmit('form')">确定</wk-button>
      <wk-button class="exportButton" @click="closeModal()">取消</wk-button>
    </div>
  </el-dialog>
</template>

<script>

  export default {
    props:['menuData'],
    data() {
			return {
        title:'',
				dialogVisible:false,
        uploadErrorInfo:'',
        formData:{
          id:"",
          publishState:3,
          publishTime:"",
          pdfUrl:"",
          desc:"",
        },
        ruleData: {//角色表单校验
          publishState: [
            {required: true, message: '请选择', trigger: 'blur'},
          ],
          publishTime: [
            {required: true, message: '请选择', trigger: 'blur'},
          ],
          pdfUrl: [
            {required: true, message: '请上传',  trigger: ['change', 'blur']},
          ],
        },
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 86400000;
          }
        }
			}
    },
    created(){
      
    },
    methods: {
      show(id='') {
        if(id){
          this.formData.id= id;
          this.queryPDFCenterDetail()
        }
        this.dialogVisible = true;
      },
      closeModal() {
        this.dialogVisible = false;
        this.$emit('queryPDFCenterList', {})
        this.resetForm();
      },
      resetForm() {
        this.$refs['form'].resetFields();
      },
      handleImgChange(res) {
        this.uploadErrorInfo = ''
        if (res['code'] == 0) {
          this.formData.pdfUrl = res.data.link
          this.$refs['form'].validateField('pdfUrl');//对图片进行移除校验
        } else {
          this.uploadErrorInfo = result.message
        }
      },
      queryPDFCenterDetail(res) {
        this.$apis.documentPDFServer.queryPDFCenterDetail({
          id:this.formData.id,//	必选	int	id
        }).then(res=>{
          if (res['code'] == 0){
            this.formData = res['data']
          }
        })
      },
      onSubmit(formName){
        this.$refs[formName].validate((valid) => {
          if(valid){
            console.log(this.formData)
            if(this.formData.id){
               this.$apis.documentPDFServer.updatePDFCenter({
                id:this.formData.id,//	必选	int	id
                pdfMenuId:this.$route.query.pdfMenuId,//	必选	int	导航id
                publishState:this.formData.publishState,//	必选	int	发布状态2定时发布3立即发布
                publishTime:this.formData.publishState==2?this.formData.publishTime:'',//	可选	int	定时发布时间
                pdfUrl:this.formData.pdfUrl,//	必选	pdf地址
                desc:this.formData.desc,//	可选	描述
              }).then(res=>{
                if (res.code == 0) {
                  this.$message('编辑成功');
                  window.location.reload();
                }
              })
            }else {
              this.$apis.documentPDFServer.addPDFCenter({
                pdfMenuId:this.$route.query.pdfMenuId,//	必选	int	导航id
                publishState:this.formData.publishState,//	必选	int	发布状态2定时发布3立即发布
                publishTime:this.formData.publishState==2?this.formData.publishTime:'',//	可选	int	定时发布时间
                pdfUrl:this.formData.pdfUrl,//	必选	pdf地址
                desc:this.formData.desc,//	可选	描述
              }).then(res=>{
                if (res['code'] == 0){
                  this.$message('上传成功');
                  window.location.reload();
                }
              })
            } 
          }       
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
.title{
  font-size: 18px;
}
.footer{
  margin-top: 20px;
  text-align: center;
  .exportButton{
    width: 150px;
    margin: 0 22px;
    letter-spacing: 6px !important;
  }
}
</style>
